export enum ResourceType {
  microLesson = "microLesson",
  istationLegacyActivity = "istationLegacyActivity",
  tutor = "tutor",
  skillTutor = "skillTutor",
  teacherResource = "teacherResource",
  textSet = "textSet",
  EPS = "EPS",
  ERSS = "ERSS",
}
